import { render, staticRenderFns } from "./Required.vue?vue&type=template&id=6445be68&scoped=true&"
import script from "./Required.vue?vue&type=script&lang=js&"
export * from "./Required.vue?vue&type=script&lang=js&"
import style0 from "./Required.vue?vue&type=style&index=0&id=6445be68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6445be68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6445be68')) {
      api.createRecord('6445be68', component.options)
    } else {
      api.reload('6445be68', component.options)
    }
    module.hot.accept("./Required.vue?vue&type=template&id=6445be68&scoped=true&", function () {
      api.rerender('6445be68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/CourseRequestForms/Required.vue"
export default component.exports